export const CATEGORY_LIMIT = 100;
export const CATEGORY_NAME_LENGTH_LIMIT = 40;
export const CATEGORY_PROPERTIES_MAX_LENGTH = 100;
export const CATEGORY_VARIATIONS_MAX_LENGTH = 2;
